import React, { useState } from "react";
import { Globe, Check, Search as SearchIcon } from "lucide-react";
import { useI18n, LANGUAGES } from "@/contexts/I18nContext";

const LanguageSwitcher = ({ compact = false }) => {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
  const filtered = q
    ? LANGUAGES.filter((l) =>
        l.label.toLowerCase().includes(q.toLowerCase()) ||
        l.native.toLowerCase().includes(q.toLowerCase()) ||
        l.short.toLowerCase().includes(q.toLowerCase())
      )
    : LANGUAGES;

  return (
    <div className="relative" data-testid="lang-switcher">
      <button
        onClick={() => setOpen((s) => !s)}
        className={`flex items-center gap-1.5 ${compact ? "px-2 py-1 text-xs" : "px-2 sm:px-3 py-1.5 text-xs"} hover:bg-white/15 rounded`}
        aria-label="Change language"
        data-testid="lang-btn"
      >
        <Globe className="w-3.5 h-3.5" />
        <span className="font-semibold">{current.short}</span>
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-1 w-64 bg-white border border-border rounded-xl shadow-xl z-50 text-foreground overflow-hidden" data-testid="lang-menu">
            <div className="p-2 border-b border-border bg-muted/30 sticky top-0">
              <div className="flex items-center gap-2 bg-white border border-border rounded-lg px-2.5 py-1.5">
                <SearchIcon className="w-3.5 h-3.5 text-muted-foreground" />
                <input
                  autoFocus
                  value={q}
                  onChange={(e) => setQ(e.target.value)}
                  placeholder="Search 23 languages…"
                  className="flex-1 text-xs bg-transparent focus:outline-none"
                  data-testid="lang-search"
                />
              </div>
              <div className="text-[10px] text-muted-foreground mt-1.5 px-1">22 भारतीय भाषाएँ + English</div>
            </div>
            <div className="max-h-72 overflow-y-auto py-1">
              {filtered.length === 0 ? (
                <div className="px-3 py-4 text-xs text-muted-foreground text-center">No language matches "{q}"</div>
              ) : (
                filtered.map((l) => (
                  <button
                    key={l.code}
                    onClick={() => { setLang(l.code); setOpen(false); setQ(""); }}
                    className="w-full flex items-center justify-between px-3 py-2 text-sm hover:bg-accent/40 text-left"
                    data-testid={`lang-opt-${l.code}`}
                  >
                    <div className="flex flex-col min-w-0">
                      <span className="font-medium truncate">{l.native}</span>
                      <span className="text-[10px] text-muted-foreground">{l.label}</span>
                    </div>
                    {lang === l.code && <Check className="w-4 h-4 text-primary shrink-0" />}
                  </button>
                ))
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSwitcher;
